import i18n from 'modules/core/lib/i18n'

export const asShortDay = (day: string): string | undefined => {
  switch (day) {
    case 'monday':
      return i18n.t(`hiring.work_days.monday`)
    case 'tuesday':
      return i18n.t(`hiring.work_days.tuesday`)
    case 'wednesday':
      return i18n.t(`hiring.work_days.wednesday`)
    case 'thursday':
      return i18n.t(`hiring.work_days.thursday`)
    case 'friday':
      return i18n.t(`hiring.work_days.friday`)
    case 'saturday':
      return i18n.t(`hiring.work_days.saturday`)
    case 'sunday':
      return i18n.t(`hiring.work_days.sunday`)
  }
}
